<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EM1mTX/tc-custom/9781423651673.jpg?1738411869375" alt="This image is the cover for the book Grand Canyon Expedition"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Grand Canyon Expedition
      </h1>
      <p class="bookDescription body article font2">
        <b>The geologist and explorer’s own account of his perilous venture into one of the last unmapped portions of the continental United States.</b><br/><br/>Join John Wesley Powell’s expedition to explore one of the Seven Wonders of the Natural World, and one of the last unmapped portions of the continental United States. Powell’s detailed descriptions of the rocks, plants, and animals seen in the canyon; the geography of the area; his team’s interactions with native groups; and dangers and mishaps along the trail allow readers to feel the thrill, the awe, and the humility of standing on the canyon’s edge.<br/><br/>After losing an arm in the Civil War, the young Powell took on an extraordinary challenge as he led a small team into this remarkable landscape. He would go on to become the director of the US Geological Survey and the Smithsonian, and is acknowledged today for his foresight on the importance of conserving natural resources—particularly water—as the nation rapidly expanded westward.<br/><br/>“Powell’s ideas powerfully shaped development of the West’s water supply.” —<i>Scientific American </i><br/><br/>“He had entered the Grand Canyon as a pioneer, hoping that it could be exploited and settled, but the experience changed him. He realized that the presence of indigenous peoples, the landscape, water and ecosystems meant that it could not and should not be settled as the Eastern states had been. Now, as the Western states are threatened with a catastrophic water shortage, it is possible that he should be remembered not just as an explorer, but also as a prophet.” —<i>BBC News Magazine</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Wesley Powell
      </h2>
      
      <p class="authorDescription body article"><P><B>John Wesley Powell</B> (1834–1902) was a soldier, geologist, professor, explorer, and director of the U.S. Geological Survey. In 1869, he embarked on a three-month journey down the Colorado River, which would become the first recorded voyage through the Grand Canyon.</P><br/><br/></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gibbs Smith
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2134d931